import React from 'react';
import { Carousel } from "react-bootstrap";
import classnames from 'classnames';
import NewFeaturedProductInner from './new-featured-product-inner';

import './new-feature.css';
import './card.css';

class NewFeaturedProductCard extends React.Component {
    constructor(props) {
      super(props);
    }

    componentDidMount() {
      this.updateCssVars();
    }

    updateCssVars() {
      const { products } = this.props;
      products.forEach((product, key) => {
        if (this.refs[`carouselItem${key}`]) {
          this.refs[`carouselItem${key}`].style.setProperty('--carousel-background-image', `url(${product.attributes.links['marketing-image']})`);
        }
      });
    }

    render() {
      const { products } = this.props;

      return (
        <Carousel indicators={false} controls={products.length > 1}>
          {products.map((product, key) => (
            <Carousel.Item key={key}>
              <div ref={`carouselItem${key}`} className={`${classnames('carousel-image', 'featured-product-carousel-info')} carousel-background-image`}>
                <NewFeaturedProductInner product={product} handleConfirmation={this.props.handleConfirmation} />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      );
    }
}

export default NewFeaturedProductCard;


// WEBPACK FOOTER //
// ./src/components/new-order/new-featured-product-card.jsx